import React from "react";
import { css } from "@emotion/react";
import { FieldLabel, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";

type Props = {
  email: string;
};

export const EmailLabel = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <FieldLabel>メールアドレス</FieldLabel>
      </div>
      <div css={inputWrapper}>
        <Font>{props.email}</Font>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  paddingTop: "8px",
  flex: 1,
});
